<template>
   <div class="page-table-layout" data-testid="infomanager-new">
    <v-card :loading="loading" class="all-width flex-card shadow-off" :disabled="loading" loader-height="2" data-testid="infomanager-new__main-card">
        <v-card-text class="page-table-layout__body" data-testid="infomanager-new__main-content">
          <div class="d-flex align-center justify-space-between" data-testid="infomanager-new__header-bar">
            <div class="d-flex" data-testid="infomanager-new__header-title-group">
              <h3 class="ma-0 black--text font-weight-semibold" data-testid="infomanager-new__header-title">Information Manager</h3>
              <v-tooltip bottom content-class="tooltip-bottom" >
                <template v-slot:activator="{ on, attrs }"> 
                    <v-btn 
                        v-bind="attrs"
                        v-on="on"
                        class="shadow-off ml-1" icon @click="refreshData()" data-testid="infomanager-new__refresh-btn"><v-icon
                        size="24" data-testid="infomanager-new__refresh-icon">mdi-refresh</v-icon>
                    </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
              <activity-log
                      :resource-id="clientID" 
                      data-testid="infomanager-new__datatable-activity-log-btn"
                      row-description="Information Manager"
                      :type="$options.ACTIVITY_LOG_TYPES.MASTER_IM"  
                  />
            </div>
            <div class="d-flex align-center ma-0" data-testid="infomanager-new__header-action-group">
                <bulkPBCUpload @reload="refreshData()" :checklist="checklist" v-if="$nova.hasRight(right, 'add')" data-testid="infomanager-new__bulk-upload"/>
                <v-btn  color="primary" class="mr-1 px-4" 
                   @click="addRequirement()"
                     v-if="$nova.hasRight(right, 'add')" data-testid="infomanager-new__add-btn">
                <v-icon class="pr-2" data-testid="infomanager-new__add-icon">mdi-plus</v-icon>
                <span class="text-capitalize"><span data-testid="infomanager-new__add-label">New Requirement</span></span>
              </v-btn>
            </div>
          </div>
          <div class="d-flex align-center justify-space-between my-3 " data-testid="infomanager-new__toolbar">
            <!-- /* TODO: Temporarily set to display: none; for current requirements. Will be updated in future versions. */ -->
              <div class="d-none" data-testid="infomanager-new__search-hidden"> 
            <lb-string placeholder="Search" label="" v-model="search" width="30vh" appendiconinner="mdi-magnify" hidedetails
              :isClearable="false" radius="8px" data-testid="infomanager-new__search-input" />
              <v-tooltip bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ma-2" text icon color="lighten-2" v-bind="attrs" v-on="on" data-testid="infomanager-new__search-info-btn">
                    <v-icon data-testid="infomanager-new__search-info-icon">mdi-information</v-icon>
                    </v-btn>
                </template>
                <span>Search for the request information </span>
                </v-tooltip>
              </div>
            <v-spacer></v-spacer>

            <v-menu v-if="selectItem.length>0" class="radius-small" :close-on-content-click="false" offset-y transition="slide-y-transition" data-testid="infomanager-new__bulk-menu">
              <template v-slot:activator="{ on, attrs }">
                <v-tooltip left content-class="tooltip-left">
                  <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                  <v-btn icon v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }"  class="ml-2" data-testid="infomanager-new__bulk-btn"><v-icon data-testid="infomanager-new__bulk-icon">mdi-dots-horizontal</v-icon></v-btn>
                  </template>
                  <span>Bulk actions</span>
                </v-tooltip>
              </template>
              <v-list  class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width" data-testid="infomanager-new__bulk-list">
              <v-list-title class="ma-0  all-width" data-testid="infomanager-new__bulk-list-title">
                <div class="d-flex tableHeaderBg align-center pa-2 pb-3 pt-3 pb-1 justify-space-between">
                  <p class="ma-0 font-weight-bold" data-testid="infomanager-new__bulk-list-title-label">Bulk Actions</p>
                  <v-icon color="primary" data-testid="infomanager-new__bulk-list-title-icon">mdi-information-outline</v-icon>
                </div>
                <v-divider></v-divider>
              </v-list-title>
              <v-list-item  class="d-flex px-2 all-width align-center  pa-0 ma-0 gray--text" @click="editRequestUser=true;getrequstedfromusers()" data-testid="infomanager-new__bulk-edit-requested-btn">
                <v-icon data-testid="infomanager-new__bulk-edit-requested-icon">mdi-pencil-outline</v-icon>
                <span class="noTransform" data-testid="infomanager-new__bulk-edit-requested-label">Edit 'Requested from'</span>
              </v-list-item>
            </v-list>
            </v-menu>
  
            <!-- Clear Filter Button -->
            <v-btn
              v-if="hasActiveTableFilter"
              outlined
              small
              class="mr-2"
              color="caccounting"
              @click="clearTableFilter()"
              data-testid="infomanager-new__toolbar-clear-filter-btn"
            >
              <v-icon left data-testid="infomanager-new__toolbar-clear-filter-icon">mdi-filter-remove</v-icon>
              <span>Clear Filter</span>
            </v-btn>
            <!-- Customize Column Menu Component -->
            <CustomizeColumnMenu
              v-model="customizeMenuOpen"
              :headers="headers"
              :show-save-button="false"
              data-testid-prefix="infomanager-new"
              @apply="handleApplyColumns"
            />
          </div>
          <div class="flex-fill-table">
          <lb-datatableaction
            ref="dataTableAction"
            :headers="headers"
            :tabledata="formateDataCopy"
            :itemsperpage="itemsPerPage"
            :displayedRowCount="paginatedFilteredItems.length"
            :searchterm="search"
            @select-all-change="select"
            :isDataSelected="selectItem.length > 0 && selectItem.length < paginatedFilteredItems.length ? true: false"
            @filter-item="filterPart"
            @filter-active-change="onFilterActiveChange"
            @clear-item="clearPart"
            data-testid="infomanager-new__datatable"
          >
            <template v-slot:tbody>
              <tr v-for="item in paginatedFilteredItems" :key="item._id" class="cursor-pointer"
                :class="{ 'low-opacity': item.status === false }"
                data-testid="infomanager-new__datatable-row">
                <td class="px-2 d-flex align-center justify-center" data-testid="infomanager-new__datatable-row-checkbox">
                  <v-checkbox dense color="caccounting" class="ma-0 py-1 single-line" :ripple="false" hide-details
                    :value="item['_id']" v-model="selectItem" @click="removeAllSelect()" data-testid="infomanager-new__datatable-checkbox"></v-checkbox>
                </td>
                <template v-for="(header,index) in headers">
                  <td v-if="header.visible && header.value !== 'action'" :key="index" class="px-2 single-line" :class="{'description-header': header.value === 'description'}"
                    data-testid="infomanager-new__datatable-cell">
                    <div v-if="header.value === 'tasklist'">
                      <div v-if="(item.tasklist || []).length > 0">
                        <template>
                          <v-tooltip bottom content-class="tooltip-bottom">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-if="item.tasklist?.[0].checklist_id" v-bind="attrs" v-on="on" class="pa-2 caccounting-background radius-mini caccounting--text mr-2" :key="index" data-testid="infomanager-new__datatable-tasklist-ref">{{(getTaskName(item.tasklist?.[0].checklist_id)).ref }}</span>
                            </template>
                            <div class="pa-2 ma-0 d-flex flex-column" style="max-width:20vh" data-testid="infomanager-new__datatable-tasklist-tooltip">
                              {{(getTaskName(item.tasklist?.[0]?.checklist_id)).description }}
                              <p class="mt-2">
                                <v-icon class="mr-2" color="white" data-testid="infomanager-new__datatable-tasklist-location-icon">mdi-map-marker</v-icon>
                                {{(getLocationName(item.tasklist?.[0]?.location)) }}
                              </p>
                            </div>
                          </v-tooltip>
                          <span v-if="item.tasklist.length >2 && item.tasklist?.[0].checklist_id"
                            class="radius-mini caccounting-background radius-mini font-size-xm caccounting--text pa-2"
                            data-testid="infomanager-new__datatable-tasklist-more">+{{ item.tasklist.length - 2 }}</span>
                        </template>
                      </div>
                    </div>
                    <div class="d-flex" v-else-if="header.value === 'location'">
                      <div class="d-flex">
                        <p class="ma-0 mt-2 mr-2" data-testid="infomanager-new__datatable-location">{{(getLocationName(item.tasklist?.[0]?.location)) }}</p>
                        <span v-if="item.tasklist.length >2 && item.tasklist?.[0]?.checklist_id"
                          class="radius-mini caccounting-background radius-mini font-size-xm caccounting--text pa-2"
                          data-testid="infomanager-new__datatable-location-more">+{{ item.tasklist.length - 2 }}</span>
                      </div>
                    </div>
                    <div class="d-flex" v-else-if="header.value === 'task_category'">
                      <div class="d-flex">
                        <p class="ma-0 mt-2 mr-2" data-testid="infomanager-new__datatable-task-category">{{(getTaskName(item.tasklist?.[0]?.checklist_id)).category }}</p>
                      </div>
                    </div>
                    <span v-else data-testid="infomanager-new__datatable-generic">{{ getItemData(item, header.value) }}</span>
                  </td>
                </template>
                <td class="px-3 single-line border-right border-left action-data" data-testid="infomanager-new__datatable-actions">
                  <v-tooltip left content-class="tooltip-left">
                    <template v-slot:activator="{ on }">
                      <v-btn icon @click="addEditForm(item)" v-on="on" :disabled="!item.status" data-testid="infomanager-new__datatable-edit-btn"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                    </template>
                    Edit
                  </v-tooltip>
                  <v-tooltip bottom content-class="tooltip-bottom" v-if="item.status">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon @click="enableDisableAccess(item._id, 'disable')" data-testid="infomanager-new__datatable-disable-btn"><v-icon color="success">mdi-check-circle</v-icon></v-btn>
                    </template>
                    <span>Enable</span>
                  </v-tooltip>
                  <v-tooltip bottom content-class="tooltip-bottom" v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon @click="enableDisableAccess(item._id, 'enable')" data-testid="infomanager-new__datatable-enable-btn"><v-icon color="error">mdi-close-circle</v-icon></v-btn>
                    </template>
                    <span>Disable</span>
                  </v-tooltip>
                  <activity-log
                      :resource-id="item._id" 
                      data-testid="infomanager-new__datatable-activity-log-btn"
                      :row-description="item.description"
                  />

                </td>
              </tr>
            </template>
          </lb-datatableaction>
          </div>

        </v-card-text>
      </v-card>
    
      <lb-drawer
        v-model="addeditdialog"
        :heading="addeditdata._id ? 'Update' : 'Create New Request'"
        width="600"
        :loading="addeditloading"
        data-testid="infomanager-new__drawer"
      >
        <template v-slot:body>
          <div>
            <v-row>
                    
              <v-col cols="12" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Requested Information*</p>
                <lb-textBox v-model="addeditdata.description" label="" requriedrows="3"
                  :error="addeditdataerror.description" data-testid="infomanager-new__textbox"/>
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Requested From*</p>
                <lb-string v-model="addeditdata.info_owner_name" label=""  :error="addeditdataerror.info_owner_name" data-testid="infomanager-new__name-string" />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Email*</p>
                <lb-string v-model="addeditdata.info_owner_email" label="" 
                  :error="addeditdataerror.info_owner_email" data-testid="infomanager-new__email-string" />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Type*</p>
                <lb-dropdown
                    v-model="addeditdata.type"
                    label=""
                    :items="informationtypes"
                    :error="addeditdataerror.type"
                    data-testid="infomanager-new__type-dropdown"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Priority</p>
                <lb-dropdown
                    v-model="addeditdata.priority"
                    label=""
                    :items="requestpriority"
                    :error="addeditdataerror.priority"
                    data-testid="infomanager-new__priority-dropdown"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Classification</p>
                <lb-string 
                    v-model="addeditdata.category"
                    label=""
                    :hidedetails="true"
                    :error="addeditdataerror.category"
                    data-testid="infomanager-new__classification-string"
                />
              </v-col>
              <v-col cols="6" class="my-0 py-1">
                <p class="pa-0 ma-0  text-font-size-md mb-1">Due Days</p>
                <lb-number  v-model="addeditdata.duedate" placeholder="Enter value between 1 and 200"
                label="" :error="addeditdataerror.category" data-testid="infomanager-new__duedate-number"/>
              </v-col>
              <v-col cols="12">
                    <span class="font-size-lg font-weight-semibold"> Select Tasks:</span>
                    <br />
                      <div class="align-center justify-start">
                      <template
                        v-for="(item, index) in selectedTask"
                      >
                      <v-chip
                        label
                        class="caccounting--text lightpurple ma-1"
                        :key="index"
                        close
                        @click:close="toggleTaskSelection(item)"
                        data-testid="infomanager-new__selected-task-chip"
                      >
                          <span>{{ getTaskName(item.checklist_id).ref  }}</span>
                        </v-chip>
                      </template>
                      </div>
                </v-col>

                <v-col cols="12" class="my-0 py-1">
                    <v-menu
                      :close-on-content-click="false"
                      offset-y
                      transition="slide-y-transition"
                      ref="accountMenu"
                      data-testid="infomanager-new__task-menu"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-bind="attrs"
                          v-on="on"
                          class="all-width align-center border-on justify-space-between"
                          data-testid="infomanager-new__task-btn"
                          ><span>Select Task</span
                          ><v-icon>mdi-chevron-down</v-icon></v-btn
                        >
                      </template>
                      
                      <v-list
                        class="ma-0 d-flex flex-column align-start justify-start all-width pa-2"
                      >
                        <div class="custom-task-list">
                          <lb-string
                            label="Search"
                            class="all-width"
                            hidedetails
                            v-model="searchTasks"
                            @input="searchTasks = $event"
                            data-testid="infomanager-new__task-search"
                          />
                          <v-simple-table dense class="all-width mt-2 border-on radius-small">
                            <thead class="tableHeaderBg">
                              <tr>
                                <th class="gray-background">
                                  <v-checkbox
                                    v-if="multiSelectMode"
                                    class="ma-0 pa-0"
                                    hide-details
                                    color="caccounting"
                                    :input-value="selectAllTask"
                                    @change="selectAllTask = !selectAllTask; toggleSelectAllTasks()"
                                    data-testid="infomanager-new__select-all-checkbox"
                                  ></v-checkbox>
                                </th>
                                <th class="gray-background" scope="ref">Ref</th>
                                <th class="gray-background" scope="location">
                                  {{ $store.state.LocationHeader || "Location" }}
                                </th>
                                <th class="gray-background" scope="ref">Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(v, k) in filteredTaskList">
                                <tr :key="k">
                                  <td>
                                    <v-checkbox
                                      class="mt-0"
                                      dense
                                      label=""
                                      hide-details
                                      :input-value="isTaskSelected(v)"
                                      @change="toggleTaskSelection(v)"
                                      data-testid="infomanager-new__task-checkbox"
                                    ></v-checkbox>
                                  </td>
                                  <td>{{ v.ref }}</td>
                                  <td>{{ v.location_name }}</td>
                                  <td>{{ v.description }}</td>
                                </tr>
                              </template>
                            </tbody>
                          </v-simple-table>
                        </div>
                        <!-- Selected Accounts Table -->
                      
                        <div class="d-flex align-center all-width justify-end mt-2">
                          <v-btn
                            data-testid="infomanager-new__select-button"
                            class="ml-2 white--text"
                            color="primary"
                            @click="$refs.accountMenu.isActive = false; selectTasks();"
                            ><span>Select</span></v-btn
                          >
                        </div>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" class="my-0 py-1">
              <div v-if="selectedTask.length > 0" class="mt-4">
                <div>
                  <v-simple-table class="all-width mt-2 border-on radius-small selected-accounts-scroll">
                    <thead class="tableHeaderBg">
                      <tr>
                        <th class="tableHeaderBg pa-2" data-testid="infomanager-new__reference-header">Reference</th>
                        <th class="tableHeaderBg pa-2" data-testid="infomanager-new__location-header">Location</th>
                        <th class="tableHeaderBg pa-2" data-testid="infomanager-new__description-header">Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in selectedTask" :key="index">
                        <td data-testid="infomanager-new__reference-cell">{{ getTaskName(item.checklist_id).ref }}</td>
                        <td data-testid="infomanager-new__location-cell">{{ getLocationName(item.location) }}</td>
                        <td data-testid="infomanager-new__description-cell">{{ getTaskName(item.checklist_id).description }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
                        </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption">*Required</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addEditItem()" data-testid="infomanager-new__drawer-save-btn">
            <span v-if="addeditdata._id" data-testid="infomanager-new__drawer-update-btn">Update</span>
            <span v-else data-testid="infomanager-new__drawer-create-btn">Create Request</span>
          </v-btn>
        </template>
      </lb-drawer>

      <lb-drawer
        v-model="editRequestUser"
        heading="Edit 'Request From'"
        width="600"
        data-testid="infomanager-new__edit-request-drawer"
      >
        <template v-slot:body>
          <div class="" data-testid="infomanager-new__edit-request-body">
            <v-row>
              <v-col cols="6" data-testid="infomanager-new__edit-request-chip-col">
                <v-chip color="lightpurple" class="caccounting--text" data-testid="infomanager-new__edit-request-chip">
                  <v-icon class="mr-1" data-testid="infomanager-new__edit-request-chip-icon">mdi-information-outline</v-icon>
                  <span data-testid="infomanager-new__edit-request-chip-label">{{ selectItem.length }} information requests selected</span>
                </v-chip>
              </v-col>
              <v-col cols="12" data-testid="infomanager-new__edit-request-actions-col">
                <p class="ma-0 mb-1" data-testid="infomanager-new__edit-request-actions-label">Actions</p>
                <lb-dropdown label="" hidedetails :items="editRequestActions" data-testid="infomanager-new__edit-request-actions-dropdown"/>
              </v-col>
              <v-col cols="12" data-testid="infomanager-new__edit-request-existing-col">
                <p class="ma-0 mb-1" data-testid="infomanager-new__edit-request-existing-label">Existing</p>
                <lb-string label="" v-model="edituserlist.exiting_info_owner_name" hidedetails data-testid="infomanager-new__edit-request-existing-string"/>
              </v-col>
              <v-col cols="12" data-testid="infomanager-new__edit-request-email-col">
                <p class="ma-0 mb-1" data-testid="infomanager-new__edit-request-email-label">Email ID</p>
                <lb-string label="" v-model="edituserlist.exiting_info_owner_email" hidedetails data-testid="infomanager-new__edit-request-email-string"/>
              </v-col>
              <v-col cols="12" data-testid="infomanager-new__edit-request-replace-col">
                <p class="ma-0 mb-1" data-testid="infomanager-new__edit-request-replace-label">Replace With</p>
                <!-- <lb-string label="" v-model="edituserlist.new_info_owner_name" hidedetails/> -->
                <!-- <lb-dropdown v-model="edituserlist.new_info_owner_name" :items="usersList"  label="" placeholder="Select New Information manager"
                :error="addeditdataerror.glcode"  itemtext="name"
                itemvalue="email"/> -->

                <v-select
                  v-model="selectedUser"
                  :items="usersList"
                  item-value="_id"
                  item-text="name"
                  label="Select User"
                  @change="updateUserInfo"
                  outlined
                  data-testid="infomanager-new__edit-request-replace-select"
                >
                </v-select>

              </v-col>
              <!-- <v-col cols="12">
                <p class="ma-0 mb-1">Email Id</p>
                <lb-string label="" v-model="edituserlist.new_info_owner_email" hidedetails/>
              </v-col> -->
            </v-row>
          </div>
        </template>
        <template v-slot:actions>
          <span class="caption" data-testid="infomanager-new__edit-request-actions-required">*Required</span>
          <v-spacer></v-spacer>
          <v-btn class="py-4" color="primary" @click="updaterequesteduser()" data-testid="infomanager-new__edit-request-actions-replace-btn">
            <span data-testid="infomanager-new__edit-request-actions-replace-label">Replace</span>
          </v-btn>
        </template>
      </lb-drawer>

      <!-- Pagination -->
      <Pagination :list="filteredItemsfromsearch" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="financialstatement-preparation__pagination" />

   </div>
</template>
  
  <script>
  import bulkPBCUpload from "../../components/BulkUploadInformationManager/BulkUploadInformationManager.vue";
  import Pagination from "../../components/Pagination/Pagination.vue";
  import CustomizeColumnMenu from "../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue";
  import ActivityLog from "../../components/ActivityLog/ActivityLog.vue";
  import { ACTIVITY_LOG_TYPES } from "../../utils/constants";
  export default {
    name: "financialclose_master_informationmanager",
     ACTIVITY_LOG_TYPES,
    // props: ['props'],
    data: function () {
      return {
        right: "financialclose_master_informationmanager",
        clientID:this.$store.state.client,
        addeditdata: {},
        addeditdataerror: {},
        informationtypes: [
          { value: "text", name: "Text" },
          { value: "fileupload", name: "File Upload" },
        ],
        requestpriority:[
            "High",
            "Medium",
            "Low"
        ],
        addeditdialog: false,
        checklist: [],
        addeditloading: false,
        addedittaskloading: false,
        addedittaskdialog:false,
        loading: false,
        hasActiveTableFilter: false,
        listdata: [],
        headers: [
          {
            value: "indexno",
            text: "S No",
            visible: true,
            filterable:false,
            sortable: false,

          },
          {

            value: "description",
            text: "Request Information",
            visible: true,
            filterable:true,
            sortable: true,

          },
          {
            value: "type",
            text: "Type",
            visible: true,
            filterable:true,
            sortable: true,
          },
  
          {
            value: "category",
            text: "Classification",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "info_owner_name",
            text: "Requested From",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "info_owner_email",
            text: "Email ID",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "tasklist",
            text: "Task Linked",
             visible: true,
            filterable:false,
            sortable: false,
          },
          {
            value:"task_category",
            text:"Task Category",
             visible: true,
            filterable:false,
            sortable: false,
          },
          {
            value: "duedate",
            text: "Due Days",
            visible: true,
            filterable:false,
            sortable: false,
          },
          {
            value: "location",
            text: this.$store.state.LocationHeader || 'Location',
             visible: true,
            filterable:false,
            sortable: false,
          },
          {
            value: "created_at",
            text: "Created On",
             visible: true,
            filterable:true,
            sortable: true,
          },
          {
            value: "updated_at",
            text: "Updated On",
             visible: true,
             filterable:true,
            sortable: true,
          },
          {
            value:"priority",
            text:"Priority",
             visible: true,
            filterable:false,
            sortable: false,
          },
          {
            value: "action",
            text: "Action",
            sticky:true,
            visible: true,
            filterable:false,
            sortable: false,
          },
        ],
        selectedTaskHeaders:[
          {  title: 'Reference', align: 'start', key: 'ref',},
          { title: 'Descriptions', align: 'end', key: 'checklist' },
          { title: 'Location', align: 'end', key: 'location' },
          { title: 'Actions', value: 'actions', sortable: false },

        ],
        formatedData: [],
        formateDataCopy:[],
        selectchecklist_id:'',
        selectlocation_id:'',
        tasklistlocation:[],
        addedittaskdataerror:{},
        location_details:[],
        tasklocation_details:[],
        locationfilter:[],
        selectedFilterItems: [],
        searchTask:'',
        selecttaskstep:0,
        searchcolumn:'',
        customizeMenuOpen: false,
        search:"",
        itemsPerPage:13,
        selectAll:false,
        selectItem:[],
        editRequestUser:false,
        editRequestActions:["Replace"],
        paginatedFilteredItems:[],
        edituserlist:{},
        usersList:[],
        selectedUser:null,
        selectedTask: [], // Array of selected account objects or IDs
        selectAllTask: false, // For multi-select "select all"
        multiSelectMode: true,
        searchTasks:'',
        activeFilter: null,
      };
    },
    created() {
      this.init();
    },
    activated() {
      this.init();
    },
    components: {
      bulkPBCUpload,
      Pagination,
      CustomizeColumnMenu,
     ActivityLog
    },
    computed:{
       filteredTaskList() {
        const term = (this.searchTasks || '').toLowerCase();
        if (!term) return this.filterTasklistList;
        return this.filterTasklistList.filter(v =>
          (v.description && v.description.toLowerCase().includes(term)) ||
          (v.ref && String(v.ref).toLowerCase().includes(term)) ||
          (v.location_name && v.location_name.toLowerCase().includes(term))
        );
      },
       filterTasklistList() {
        // Returns a flattened array of checklist items, each with a single location
        if (!Array.isArray(this.checklist)) return [];
        return this.checklist.flatMap(item => {
          if (item.location && item.location.length > 0) {
            return item.location.map(loc => {
              const newItem = { ...item };
              newItem.ref = `${item.ref}`;
              newItem.location_name = loc.name;
              newItem.location = loc._id;
              newItem.checklist_id = item._id;
              return newItem;
            });
          } else {
            return [];
          }
        });
      },
        filtertasklist(){            
            return this.checklist.filter(item =>
                item.description.toLowerCase().includes(this.searchTask.toLowerCase())
            );
        },

        filteredHeaders() {
          const searchTerm = this.searchcolumn.toLowerCase();
          return this.headers.filter(header =>
            header.text.toLowerCase()?.includes(searchTerm)
          );
        },
        filteredItemsfromsearch() {          
          let filteredData = this.formatedData.filter(item =>
            item.description.toLowerCase().includes(this.search.toLowerCase())
          );

          if (this.selectedFilterItems.length > 0) {
            filteredData = filteredData.filter(item => {
              return this.selectedFilterItems.every(filter => {
                return Object.entries(filter).every(([key, values]) => {
                  const itemValue = item[key];
                  return Array.isArray(itemValue)
                    ? itemValue.some(val => values.includes(val))
                    : values.includes(itemValue);
                });
              });
            });
          }

          return filteredData;
        },

    },
    methods: {
      /**
       * Handler for filter-active-change event from DataTableAction
       */
      onFilterActiveChange(isActive) {
        this.hasActiveTableFilter = isActive;
      },
      /**
       * Clear table filters via DataTableAction ref
       */
      clearTableFilter() {
        if (this.$refs.dataTableAction) {
          this.$refs.dataTableAction.clearFilter();
        }
      },
      formateData() {
        let ObjectTemp = {};
        let ArrayTemp = [];
        this.listdata.forEach((item, index) => {
          ObjectTemp = {
            __key: index,
            __formatedkey: index,
            _id: item._id,
            indexno: index + 1,
            type: item.type,
            category: item.category?.trim(),
            description: item.description?.trim(),
            duedate:item.duedate,
            info_owner_email: item.info_owner_email?.trim(),
            info_owner_name: item.info_owner_name?.trim(),
            priority: item.priority,
            urgent: item.urgent,
            tasklist: item.checklist_id,
            location:this.getLocationName(item.tasklist?.[0]?.location),
            checklist_id_detail: item.checklist_id_detail,
            created_at: item.created_at?.split("T")[0],
            updated_at: item.updated_at?.split("T")[0],
            status: item.status,
          };
          ArrayTemp.push(ObjectTemp);
        });
        this.formatedData = ArrayTemp;
        this.formateDataCopy = ArrayTemp;
      },
      init() {
        this.refreshData();
      },
      setPaginatedData(paginationInfo) {
        if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
            this.paginatedFilteredItems = paginationInfo.data || [];
            this.page = paginationInfo.page || 1;
        } else {
            this.paginatedFilteredItems = paginationInfo || [];
        }
      },
      refreshData() {
        this.charts = [];
        this.chartdata = {};
        this.listdata = [];
        this.locationfilter = [];
        this.getData();
      },
      getData() {
        this.loading = true;
        return this.axios
          .post("/v2/financialclose/masters/informationmanager/formData")
          .then((dt) => {
            if (dt.data.status === "success") {
              let formdt = dt.data.data[0] || {};
              this.checklist = formdt.checklist || [];
              return this.axios.post(
                "/v2/financialclose/masters/informationmanager/get"
              );
            } else throw new Error("Error reading form data");
          })
          .then((dt) => {
            this.listdata = [];
            if (dt.data.status === "success") {
              this.listdata = dt.data.data;
              this.formateData();
            } else throw new Error(dt.data.message);
          }).then(() => {
             this.axios
                .post("/v2/financialclose/location/get")
                .then((ele) => {
                  this.location_details = ele.data.data;
                })
                .catch((err) => {
                  console.log(err);
                });
          }).then(() => {
          return this.axios.post(
            "/v2/financialclose/masters/checklist/getformdata"
          );
        })
        .then((dt) => {
          if (dt.data.status === "success") {
            let formdata = dt.data.data[0] || {};
            this.usersList = formdata.users;
           
          } else throw new Error(dt.data.message);
        })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
          })
          .finally(() => {
            this.loading = false;
          });
      },

      /**
       * Handle Apply button click from CustomizeColumnMenu
       * Updates column visibility locally (session only)
       * @param {Array} headers - Updated headers array
       */
      handleApplyColumns(headers) {
        this.headers = headers;
        this.customizeMenuOpen = false;
      },

      addTableHeader(item) {
        this.headers.find((x) => x === item ? x.visible = !x.visible : "")
      },
      select() {
        this.selectItem = [];
        this.selectAll=!this.selectAll

        if (this.selectAll) {
          for (let i in this.paginatedFilteredItems) {
            this.selectItem.push(this.paginatedFilteredItems[i]['_id']);
          }
        } else {
          this.selectItem = [];
        }
      },
      removeAllSelect() {
        if (this.selectItem.length === this.formatedData.length) this.selectAll = true;
        else this.selectAll = false;
      },
      addForm(){
        this.addeditdata = {};
        this.addeditdataerror = {};
        this.tasklocation_details=[],
        this.addeditdialog = true;
        this.tasklistlocation = [];
      },
      addRequirement(){
         this.addeditdialog = true; 
         this.addeditdata = {};  
         this.addeditdataerror = {}; 
         this.locationUserList = []; 
         this.customassertions = false; 
         this.tasklistlocation = []; 
         this.selectedTask = [];
      },
      addEditForm(dt = {}) {
      this.addeditdata = { ...dt };
      this.selectedTask = [];
      // Sync both tasklistlocation and selectedTask with the current tasklist (if present)
      this.tasklistlocation = Array.isArray(this.addeditdata.tasklist) ? JSON.parse(JSON.stringify(this.addeditdata.tasklist)) : [];
      this.selectedTask = Array.isArray(this.addeditdata.tasklist) ? JSON.parse(JSON.stringify(this.addeditdata.tasklist)) : [];
      this.addeditdataerror = {};
      this.addeditdialog = true;
          },
      getItemData(item, key) {
        return item[key];
      },
       validateAddEditData(data) {
        let errors = {};
        let hasError = false;
        const requiredFields = [
          { key: 'description', label: 'Requested Information' },
          { key: 'info_owner_name', label: 'Requested From' },
          { key: 'info_owner_email', label: 'Email' },
          { key: 'type', label: 'Type' },
        ];
        requiredFields.forEach(field => {
          const value = data[field.key];
          if (
            value === undefined ||
            value === null ||
            (typeof value === 'string' && value.trim() === '') ||
            (Array.isArray(value) && value.length === 0)
          ) {
            errors[field.key] = `${field.label} is required`;
            hasError = true;
          }
        });
        // Email format validation
        const email = data.info_owner_email;
        if (
          email &&
          (typeof email === 'string') &&
          !/^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9\-.]+)\.([a-zA-Z]{2,})$/.test(email.trim())
        ) {
          errors.info_owner_email = 'Please enter a valid email address';
          hasError = true;
        }
        return { errors, hasError };
      },
      addEditItem() {
  // Validation
  this.addeditdataerror = {};
  const { errors } = this.validateAddEditData(this.addeditdata);
  this.addeditdataerror = errors;
  if (Object.keys(errors).length > 0) {
        this.$store.commit("sbError", "Please fill all required fields correctly.");
        return;
    }
  this.addeditloading = true;
        let type = "add";
        let url = "/v2/financialclose/masters/informationmanager/add";
        if (this.addeditdata._id) {
          type = "edit";
          url =
            "/v2/financialclose/masters/informationmanager/edit/" +
            this.addeditdata._id;
        }
        this.addeditdata.checklist_id = this.selectedTask;
        let ndt = { ...this.addeditdata };
        delete ndt._id;
        this.axios
          .post(url, { data: ndt })
          .then((dt) => {
            if (dt.data.status === "success") {
              if (type === "add")
                this.$store.commit("sbSuccess", "New Request added");
              else this.$store.commit("sbSuccess", "Request updated");
              this.addeditdialog = false;
              this.refreshData();
            } else {
              if (dt.data.data.length > 0) {
                if (dt.data.data[0].index0)
                  this.addeditdataerror = dt.data.data[0].index0;
              } else throw new Error(dt.data.message);
            }
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.addeditloading = false;
          });
      },
      enableDisableAccess(id, action) {
        this.loading = true;
        let url = "/v2/financialclose/masters/informationmanager/disable/";
        if (action === "enable") {
          url = "/v2/financialclose/masters/informationmanager/enable/";
        }
        this.axios
          .post(url + id, {})
          .then((dt) => {
            if (dt.data.status === "success") {
              if (action === "enable") {
                this.$store.commit("sbSuccess", "Item enabled");
                // this.listdata[k].status = true;
              } else {
                this.$store.commit("sbSuccess", "Item disabled");
                // this.listdata[k].status = false;
              }
              this.refreshData();
            } else throw new Error(dt.data.message || "Error performing action");
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      selectTaskLocation(id){
        this.selectlocation_id=[...this.selectlocation_id , id]        
      },
      addEditTaskItem() {
        if (this.selectchecklist_id && this.selectlocation_id) {
          this.selectlocation_id.forEach((item) => {
            let exists = this.tasklistlocation.some(
              (t) => t.checklist_id === this.selectchecklist_id && t.location === item
            );
            if (!exists) {
              let obj = {
                checklist_id: this.selectchecklist_id,
                location: item,
              };
              this.tasklistlocation.push(obj);
            }
          });
          this.addedittaskdialog = false;
        } else {
          this.$store.commit("sbError", "Tasklist and location required");
        }
        this.selectchecklist_id = "";
        this.selectlocation_id = "";
      },
      getLocationName(locationId) {
        const location = this.location_details.find(
          (loc) => loc._id === locationId
        );
        return location ? location.name : "";
      },
      getTaskName(taskId) {
        const task = this.checklist.find((task) => task._id === taskId);
        return task ? task : "";
      },
       removetasklist(item){
        let indexItem = this.tasklistlocation.indexOf(item);
        this.tasklistlocation.splice(indexItem, 1);
      },
      selectLocation(Id){
        let taskLoc = '';
        if (Id) {
           taskLoc = this.checklist.find((x) => x._id === Id);
        }        
        this.selectchecklist_id=Id
        this.tasklocation_details = taskLoc.location;        
      },
      locationFilterFun(locationid){
        this.loading = true;
        if (locationid) {
          this.axios
            .post("/v2/financialclose/masters/informationmanager/getinfomationwithfilter/"+locationid)
            .then((ele) => {
               if (ele.data.status === "success") {
                this.listdata = ele.data.data;
                this.formateData();
               }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
            this.loading = false;
          });
        }
      },
      getrequstedfromusers() {
        
        const selectedItemsData = this.formatedData.filter(item => this.selectItem.includes(item._id));
        this.edituserlist.exiting_info_owner_name = selectedItemsData.map(item => item.info_owner_name);  
        this.edituserlist.exiting_info_owner_email =selectedItemsData.map(item => item.info_owner_email); 
        this.edituserlist.ids=[...this.selectItem]
      },
      updateUserInfo() {
        const selectedUserData = this.usersList.find(user => user._id === this.selectedUser);
      if (selectedUserData) {
        this.edituserlist.new_info_owner_name = selectedUserData.name;
        this.edituserlist.new_info_owner_email = selectedUserData.email;
      }
      
    },
      updaterequesteduser(){
        this.loading = true;
          this.axios
            .post("/v2/financialclose/masters/informationmanager/updateinfouser",{data:[this.edituserlist]})
            .then((ele) => {
               if (ele.data.status === "success") {
                 this.editRequestUser=false
                this.refreshData();
               }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
            this.loading = false;
          });
      },
    filterPart(item){
      // Save filter criteria for reapplication after data refresh
      this.activeFilter = JSON.parse(JSON.stringify(item));
      this.formatedData = this.$nova.filterByDynamicCriteria(this.formateDataCopy, item);  
    },
    clearPart(item){
      console.log(item,"item");
      this.activeFilter = null;
      this.formatedData = this.formateDataCopy;
    },
    selectTasks(){
      this.addeditdata.tasklist = this.selectedTask;
    },
    toggleTaskSelection(account) {
    const minimal = { checklist_id: account.checklist_id, location: account.location };
    if (this.multiSelectMode) {
      // Multi-select: add/remove from array
      const idx = this.selectedTask.findIndex(a => String(a.checklist_id) === String(account.checklist_id) && String(a.location) === String(account.location));
      if (idx > -1) {
        this.selectedTask.splice(idx, 1);
      } else {
        this.selectedTask.push(minimal);
      }
    } else {
      // Single-select: only one can be selected
      this.selectedTask = [minimal];
    }
  },
  isTaskSelected(account) {
    // Ensure both checklist_id and location are compared as strings for robust matching
    return this.selectedTask.some(a =>
      String(a.checklist_id) === String(account.checklist_id) &&
      String(a.location) === String(account.location)
    );
  },
  toggleSelectAllTasks() {
    if (this.selectAllTask) {
       this.selectedTask = this.filterTasklistList.map(item => ({
        checklist_id: item.checklist_id,
        location: item.location
      }));
    } else {
      this.selectedTask = [];
    }
  },
},
    watch: {
      // Reapply filter when data is refreshed
      formateDataCopy: {
        handler(newList) {
          if (this.activeFilter) {
            this.formatedData = this.$nova.filterByDynamicCriteria(newList, this.activeFilter);
          } else {
            this.formatedData = newList;
          }
        },
        deep: true
      },
      selectedTask() {
        // Keep selectAllTask in sync
        this.selectAllTask = this.filterTasklistList.length > 0 &&
          this.filterTasklistList.every(account => this.isTaskSelected(account));
      },
      // If the dialog is opened with a different tasklist, update selectedTask
      'addeditdata.tasklist': {
        handler(newVal) {
          this.selectedTask = Array.isArray(newVal) ? JSON.parse(JSON.stringify(newVal)) : [];
        },
        immediate: false
      }
    },
  };
  </script>
  <style scoped>
.selected-accounts-scroll {
  max-height: 250px;
  overflow-y: auto;
}
</style>
<style scoped>
.custom-task-list {
  max-height: 35vh;
  min-width: 100%;
  overflow: scroll;
  z-index: 13 !important;
  width: 20vh;
}
</style>
  